import { useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'modules/common/components/Checkbox';
import Toggle from 'modules/common/components/Toggle';
import Button from 'modules/common/components/Button';
import { addProvidersBulk } from 'modules/categories/api';
import { status } from 'constants/general';
import { CategoryEnum } from 'constants/categories';
import appModeService from 'services/AppModeService';

import {
  ItemContainer,
  ItemDetails,
  ItemImage,
  ItemName,
  ItemWrapper,
} from './AddBranchProvidersModal.style';

const ProviderRecord = ({
  isSelected,
  name,
  image,
  branchKey,
  areaKey,
  providerTypeId,
  isExclusive,
  priceListId,
  providerName,
  parentEntityKey,
}) => {
  const [submittionStatus, setSubmittionStatus] = useState(status.SHOULD_CALL_API);
  const [localIsSelected, setLocalIsSelected] = useState(isSelected);
  const [localIsExclusive, setLocalIsExclusive] = useState(isExclusive);
  const isAlreadySaved = isSelected;
  const onExclusiveToggle = () => {
    if (!isAlreadySaved) {
      setLocalIsExclusive(!localIsExclusive);
    }
  };

  const onCheckboxClick = () => {
    if (!isAlreadySaved) {
      setLocalIsSelected(!localIsSelected);
    }
  };

  const onSave = async () => {
    if (!localIsSelected) {
      return;
    }

    setSubmittionStatus(status.SUBMITING);
    try {
      const payload = {
        priceListId: Number(priceListId),
        providerTypeId,
        providers: [
          {
            providerKey: branchKey,
            providerName,
            providerPhoto: image,
            areaKey,
            entityKey: parentEntityKey,
            exclusive: localIsExclusive,
          },
        ],
      };

      await addProvidersBulk(payload);
      setSubmittionStatus(status.SUCCESS);
      // onSelectionChange(branchKey, localIsSelected);
      // onExclusiveChange(branchKey, localIsExclusive);
    } catch (error) {
      setSubmittionStatus(status.FAIL);
    }
  };

  const renderSaveButton = () => {
    if (isAlreadySaved) {
      return <span style={{ fontSize: '12px', color: '#31A636', marginLeft: '8px' }}>✓ Saved</span>;
    }

    if (submittionStatus === status.SUBMITING) {
      return <span style={{ fontSize: '12px', color: '#666', marginLeft: '8px' }}>Saving...</span>;
    }

    if (submittionStatus === status.SUCCESS) {
      return <span style={{ fontSize: '12px', color: '#31A636', marginLeft: '8px' }}>✓ Saved</span>;
    }

    if (submittionStatus === status.FAIL) {
      return <span style={{ fontSize: '12px', color: '#DB3226', marginLeft: '8px' }}>Failed</span>;
    }

    if (localIsSelected) {
      return (
        <Button
          onClick={onSave}
          btnText="Save"
          extendButtonStyle={{
            color: '#fff',
            fontSize: '12px',
            padding: '4px 8px',
            height: '24px',
            backgroundColor: isAlreadySaved ? '#6c757d' : '#28a745',
            border: 'none',
            marginLeft: '8px',
          }}
          key={`save-${branchKey}`}
          disabled={isAlreadySaved}
        />
      );
    }

    return null;
  };

  return (
    <ItemContainer key={branchKey}>
      <ItemWrapper isEdit>
        <ItemWrapper
          style={{
            height: '40px',
            padding: '6px 13px',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Checkbox
              checked={localIsSelected}
              key={branchKey}
              handleCheckboxClick={onCheckboxClick}
              disabled={isAlreadySaved}
              checkboxObj={{
                key: branchKey,
                name: (
                  <div
                    style={{
                      display: 'flex',
                      gap: '12px',
                    }}
                  >
                    <ItemImage src={image} alt="dr-image" />
                    <ItemDetails>
                      <ItemName>{name}</ItemName>
                    </ItemDetails>
                  </div>
                ),
              }}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: '8px',
                width: '180px',
              }}
            >
              {/* Only show exclusive toggle for InClinic Services and Surgical */}
              {(providerTypeId === CategoryEnum.ClinicServices ||
                providerTypeId === CategoryEnum.Surgical) &&
                !appModeService.isEmbedded && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <span style={{ fontSize: '14px', color: '#666' }}>Exclusive</span>
                  <Toggle
                    isActive={localIsExclusive || false}
                    onClick={onExclusiveToggle}
                    isEnabled={localIsSelected && !isAlreadySaved}
                  />
                </div>
              )}
              {renderSaveButton()}
            </div>
          </div>
        </ItemWrapper>
      </ItemWrapper>
    </ItemContainer>
  );
};

ProviderRecord.propTypes = {
  isSelected: PropTypes.bool,
  name: PropTypes.string,
  image: PropTypes.string,
  branchKey: PropTypes.string,
  areaKey: PropTypes.string,
  providerTypeId: PropTypes.number,
  isExclusive: PropTypes.bool,
  priceListId: PropTypes.number,
  providerName: PropTypes.string,
  parentEntityKey: PropTypes.string,
};

export default ProviderRecord;
